// Résolution et traduction de la langue — logique pure, sans DOM.
import { translations } from '../data/translations.js';

export const SUPPORTED_LANGUAGES = ['fr', 'en'];
export const DEFAULT_LANGUAGE = 'en';

/**
 * Langue initiale : celle mémorisée si valide, sinon la première langue du navigateur
 * supportée (fr), sinon l'anglais par défaut.
 * @param {string|null|undefined} stored valeur lue depuis localStorage
 * @param {string[]} [browserLanguages] ex. navigator.languages
 */
export function resolveLanguage(stored, browserLanguages = []) {
  if (SUPPORTED_LANGUAGES.includes(stored)) return stored;
  for (const tag of browserLanguages) {
    const base = String(tag).slice(0, 2).toLowerCase();
    if (SUPPORTED_LANGUAGES.includes(base)) return base;
  }
  return DEFAULT_LANGUAGE;
}

/**
 * Résout une clé pointée ("a.b.c") dans un dictionnaire et substitue les {paramètres}.
 * Repli : la clé elle-même si elle est introuvable (jamais de plantage, jamais de "undefined" affiché).
 */
export function translate(dict, key, params = {}) {
  const value = key.split('.').reduce((o, k) => (o && typeof o === 'object' ? o[k] : undefined), dict);
  if (typeof value !== 'string') return key;
  return value.replace(/\{(\w+)\}/g, (_, name) => (name in params ? String(params[name]) : `{${name}}`));
}

/** Petit conteneur d'état de langue, indépendant des réglages dev : t() traduit toujours dans la langue courante. */
export function createI18n(initialLanguage) {
  let lang = SUPPORTED_LANGUAGES.includes(initialLanguage) ? initialLanguage : DEFAULT_LANGUAGE;
  const listeners = new Set();

  function dict() {
    return translations[lang] ?? translations[DEFAULT_LANGUAGE];
  }

  function t(key, params) {
    return translate(dict(), key, params);
  }

  function setLanguage(next) {
    if (!SUPPORTED_LANGUAGES.includes(next) || next === lang) return;
    lang = next;
    listeners.forEach((fn) => fn(lang));
  }

  function onChange(fn) {
    listeners.add(fn);
    return () => listeners.delete(fn);
  }

  return { t, getDict: dict, getLanguage: () => lang, setLanguage, onChange };
}
